export default __webpack_public_path__ + "static/gitlens-e81786613170edeae647f41700051e63.png";